export default __webpack_public_path__ + "static/media/honey_bee_icon.ffafdcd6.svg";